<template>
  <t-layout :showNav="false">
    <div class="main">
      <div class="banner">
        <img src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/main.png" />
      </div>

      <div v-if="!!detail" class="userInfo">
        <div class="icon">
          <img
            :src="
              userInfo && userInfo.head_image_url
                ? userInfo.head_image_url
                : 'https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/user-icon.png'
            "
          />
        </div>
        <div class="account">{{ detail.mobile }}</div>
        <div class="points">移动积分:{{ detail.points }}</div>
      </div>

      <div class="content" v-if="!!goodsList.length">
        <swiper class="swiper" :options="swiperOption" ref="mySwiper" @slideChange="slideChange">
          <swiper-slide v-for="(item, index) in goodsList" :key="index">
            <div class="swiper-content" :class="currentIndex == index ? 'active' : 'deActive'">
              <div class="image-wrap">
                <div class="name">{{ item.goodsName }}</div>
                <div class="points">{{ item.points }}<span>分</span></div>
              </div>
            </div>
          </swiper-slide>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>

        <div class="form">
          <van-field
            class="formItem"
            v-model="verifyCode"
            center
            clearable
            placeholder="请输入验证码"
            ref="verifyCode"
          >
            <van-button
              class="verify-btn"
              :class="timer !== 0 ? 'verify-disabled' : ''"
              :disabled="timer !== 0"
              @click="sendVerify"
              slot="button"
              size="small"
            >
              {{ timer > 0 ? timer + 's后重发' : '获取验证码' }}</van-button
            >
          </van-field>

          <div class="action">
            <div class="btn" :class="!verifyCode ? 'disabled' : ''" @click="haddleSubmit"></div>
          </div>
        </div>
      </div>

      <div v-if="!!detail">
        <div class="content empty" v-if="!goodsList.length"></div>

        <div class="tips" @click="toPrivacyPolicy">查看本活动《隐私协议政策》</div>

        <div class="rules">
          <div class="title">兑换规则</div>
          <div class="text">
            1、本次活动为移动积分兑换活动，用户兑换免税购乐帮福袋后，可在免税购乐帮使用；
          </div>
          <div class="text">2、免税购乐帮福袋有效期为30天请及时使用，避免过期；</div>
          <div class="text">3、免税购乐帮福袋使用后，奖品直接发放到免税购乐帮账户</div>
          <div class="text">4、积分一经兑换使用后不支持退回，不支持开发票；</div>
          <div class="text">5、用户兑换手机号要与登录手机号保持一致，避免无法找到兑换奖品</div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showChangeAlert"
      position="center"
      :close-on-click-overlay="true"
      round
      @close="closeHandler"
    >
      <div v-if="goodsList[currentIndex]" class="change-alert">
        <div class="head">
          <img
            class="img"
            src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/exchange-img.png"
          />
          <div class="points-1">{{ goodsList[currentIndex].points }}积分</div>
          <div class="points-2">{{ goodsList[currentIndex].cyPoints }}积分</div>
        </div>
        <div class="info">本次购买将消耗畅由积分</div>
        <div class="num">{{ goodsList[currentIndex].cyPoints }}</div>
        <div class="action">
          <div class="btn" @click="haddleConfirm"></div>
        </div>
      </div>
    </van-popup>
  </t-layout>
</template>

<script>
import { Field, CellGroup, Form } from 'vant'
import tPopup from '@/components/popup/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'activityLotteryMain',
  components: {
    swiper,
    swiperSlide,
    tPopup,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form
  },
  data() {
    return {
      swiperOption: {
        // loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      channel: '',
      userInfo: null,

      detail: null,
      currentIndex: 0,
      goodsList: [],

      orderInfo: {},

      verifyCode: '',
      timer: 0,

      showChangeAlert: false,

      currentCode: 0
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf('/article/cy/privacy') > -1) {
      this.$route.meta.isBack = true
    } else {
      this.$route.meta.isBack = false
    }
    next()
  },

  activated() {
    this.$store.commit('setTitle', '福利积分兑换')

    const options = this.$route.query
    if (options.channel) {
      let channel = options.channel || ''
      this.channel = channel
    }
    console.log('channel', this.channel)

    if (!this.$route.meta.isBack) {
      this.currentIndex = 0
      this.verifyCode = ''
      this.showChangeAlert = false
      this.getUserInfo()
    }
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.swiper
    }
  },

  methods: {
    async getUserInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      let result = await this.$api.user.getUserInfo()
      let data = result.data
      if (data.code == 0) {
        let userInfo = data.data.user_info
        this.userInfo = userInfo

        this.getLotteryChangyouPointAuth()
      } else {
        this.$toast.clear()
      }
    },

    getLotteryChangyouPointAuth() {
      const { userInfo, channel } = this
      this.$api.lotteryPoints
        .lotteryChangyouPointAuth({
          mobile: userInfo.mobile,
          // mobile: '13564888265',
          filedMsg: channel
        })
        .then(result => {
          let res = result.data
          const { data } = res.data

          this.goodsList = data.goodsList
          this.detail = res.data
        })
        .finally(() => {
          this.$toast.clear()
        })
    },

    sendVerify() {
      let _this = this
      const { detail, goodsList, currentIndex, channel } = this

      this.$toast.loading({
        message: '获取验证码...',
        forbidClick: true,
        loadingType: 'spinner'
      })

      this.$api.lotteryPoints
        .lotteryChangyouPointSendOrder({
          goodsNo: goodsList[currentIndex].goodsNo,
          outTokenId: detail.outTokenId,
          filedMsg: channel
        })
        .then(result => {
          let res = result.data
          // res = {
          //   code: 0,
          //   data: {
          //     orderId: '122323432423424355654765755',
          //     goodOrderId: 'adsaw231rfss32132134345354',
          //     points: 960,
          //     cyPoints: 800
          //   }
          // }
          if (res.code == 0) {
            _this.currentCode = currentIndex
            _this.orderInfo = res.data
            _this.timer = 60

            _this.tt = setInterval(function () {
              _this.timer = _this.timer - 1
              console.log('_this.timer', _this.timer)
              if (_this.timer <= 0) {
                clearInterval(_this.tt)
              }
            }, 1000)
            this.$toast({
              duration: 3000,
              message: '验证码已发送'
            })
          }
        })
    },

    haddleSubmit() {
      const { verifyCode } = this
      if (!verifyCode) return
      this.showChangeAlert = true
    },

    haddleConfirm() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })

      const { detail, orderInfo, goodsList, currentIndex, channel, verifyCode } = this

      this.$api.lotteryPoints
        .lotteryChangyouPointOrderPay({
          goodOrderId: orderInfo.goodOrderId,
          orderId: orderInfo.orderId,
          outTokenId: detail.outTokenId,
          points: goodsList[currentIndex].points,
          code: verifyCode,
          filedMsg: channel
        })
        .then(result => {
          let res = result.data
          // res = {
          //   code: 0
          // }
          if (res.code == 0) {
            this.$toast.clear()
            const payInfo = {
              goodOrderId: orderInfo.goodOrderId,
              points: goodsList[currentIndex].points,
              cyPoints: goodsList[currentIndex].cyPoints,
              goodsName: goodsList[currentIndex].goodsName
            }

            setTimeout(() => {
              this.$router.replace(
                `/activity/lottery/result?payInfo=${encodeURIComponent(JSON.stringify(payInfo))}`
              )
            }, 500)
          }
        })
    },

    toPrivacyPolicy() {
      this.$router.push({
        path: `/article/cy/privacy`
      })
    },

    slideChange() {
      this.currentIndex = this.swiper.activeIndex
    },

    closeHandler() {
      this.showChangeAlert = false
    }
  }
}
</script>
<style></style>
<style lang="less" scoped>
.main {
  min-height: 100vh;
  background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/bg.png');
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-bottom: 44rpx;

  .banner {
    width: 100%;
    height: 518rpx;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .userInfo {
    width: 496rpx;
    height: 72rpx;
    border-radius: 48rpx;
    background: #fff;
    box-shadow: 0 4rpx 8rpx 0 #f9dd95b3;
    margin: 0 auto 20rpx;
    display: flex;
    align-items: center;
    padding: 0 36rpx;
    font-size: 26rpx;
    color: #353738;

    .icon {
      width: 36rpx;
      height: 36rpx;
      border-radius: 18rpx;
      overflow: hidden;
      margin-right: 8rpx;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .account {
      flex: 1;
    }

    .points {
      width: 200rpx;
      text-align: right;
    }
  }

  .content {
    width: 100%;
    height: 840rpx;
    margin: 0 auto 46rpx;
    padding: 106rpx 22rpx 0;
    background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/content.png');
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    &.empty {
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/content-empty.png');
    }
  }

  .tips {
    font-size: 26rpx;
    line-height: 26rpx;
    color: #874d17;
    font-weight: 500;
    margin-bottom: 60rpx;
    text-align: center;
  }

  .rules {
    width: 702rpx;
    margin: 0 auto;
    border-radius: 12rpx;
    background: #ffffff99;
    padding: 40rpx 20rpx 32rpx;

    .title {
      color: #874d17;
      text-align: center;
      font-size: 32rpx;
      font-weight: 500;
      line-height: 32rpx;
      text-align: center;
      margin-bottom: 24rpx;
      letter-spacing: 2rpx;
    }

    .text {
      color: #874d17cc;
      font-size: 26rpx;
      line-height: 42rpx;
      letter-spacing: 2rpx;
    }
  }
}

.swiper {
  width: 100%;
  height: 300rpx;

  .swiper-slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .swiper-content {
    width: 180rpx;
    height: 204rpx;
    margin: 0 auto;
    position: relative;

    .image-wrap {
      width: 100%;
      height: 100%;
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/gift-bg.png');
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .name {
        text-align: center;
        background: linear-gradient(180deg, #fff 0%, #fff3bf 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 16rpx;
        line-height: 16rpx;
        font-weight: 500;
        margin-bottom: 72rpx;
        padding-top: 30rpx;
      }

      .points {
        text-align: center;
        background: linear-gradient(180deg, #fff 0%, #fff3bf 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 54rpx;
        line-height: 54rpx;
        font-weight: 500;
        span {
          font-size: 12rpx;
        }
      }
    }
  }

  .active {
    transform: scale(1.466);
    transition: all 0.3s ease-in 0s;
  }

  .deActive {
    transform: scale(1);
    transition: all 0.3s ease-in 0s;
  }
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 92rpx;

  .formItem {
    margin-bottom: 48rpx;
    width: 600rpx;
    height: 96rpx;
    border-radius: 48rpx;
    background: #fff;
    padding: 0 16rpx 0 32rpx;
    font-size: 30rpx;
    display: flex;
    align-items: center;
    color: #723414;

    .input {
      display: block;
      flex: 1;
      height: 100%;
    }

    .clear {
      height: 100%;
      width: 64rpx;

      .inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        display: block;
        width: 32rpx;
        height: 32rpx;
      }
    }

    .verify-btn {
      border: 0;
      box-shadow: none;
      margin: 0;
      padding: 0;
      border-radius: 0;
      background: none;
      font-weight: normal;

      display: block;
      width: 180rpx;
      height: 64rpx;
      text-align: center;
      line-height: 64rpx;
      background: #fff5dc;
      border-radius: 32rpx;
      font-size: 26rpx;
      color: #874d17;

      &.verify-disabled {
        opacity: 0.6;
      }

      &::before {
        display: none;
      }

      &::after {
        display: none;
      }
    }
  }

  .action {
    .btn {
      width: 600rpx;
      height: 112rpx;
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/button-submit.png');
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;

      &.disabled {
        opacity: 0.6;
      }
    }
  }
}

.change-alert {
  width: 634rpx;
  border-radius: 16rpx;
  background: #fff;
  padding-bottom: 80rpx;
  overflow: hidden;

  .head {
    width: 100%;
    height: 212rpx;
    background: #f2f2f2;
    border-radius: 16rpx 16rpx 0 0;
    margin-bottom: 88rpx;
    position: relative;
    color: #ee2948;
    font-size: 26rpx;
    line-height: 26rpx;
    padding: 48rpx 0 68rpx 32rpx;

    .img {
      display: block;
      width: 546rpx;
      height: 96rpx;
    }

    .points-1 {
      position: absolute;
      bottom: 32rpx;
      left: 36rpx;
      min-width: 150rpx;
      text-align: center;
    }

    .points-2 {
      position: absolute;
      bottom: 32rpx;
      left: 242rpx;
      min-width: 150rpx;
      text-align: center;
    }
  }

  .info {
    color: #49556f;
    font-size: 34rpx;
    line-height: 34rpx;
    font-weight: 500;
    text-align: center;
    margin-bottom: 24rpx;
  }

  .num {
    color: #f13b1a;
    font-size: 60rpx;
    line-height: 60rpx;
    font-weight: 500;
    margin-bottom: 60rpx;
    text-align: center;
  }

  .action {
    .btn {
      width: 388rpx;
      height: 92rpx;
      margin: 0 auto;
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/button-confirm.png');
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
